import { ErrorMessage } from "formik";
import React, { useState, useEffect } from "react";
import { Button, FormGroup, Input, Col, Label } from "reactstrap";

import { isEmail } from "../../../utils/validation";
import { useAlert } from "../../../Services/AlertContext";
import { authEndpoints } from "../../../utils/Constants";
import entities from "../../../utils/entities";
import useErrorHandler from "../../../utils/Hooks/ErrorHandler";
import useFunction from "../../../utils/Hooks/useFunction";
import { clientStaffShapeYup, supplierShapeYup } from "../../../utils/YupShapes";
import ClientStaffDetail from "../../Editors/ClientStaffDetail";
import Supplier from "../../Editors/Supplier.tsx";
import FormContainer from "../../Models/FormContainer";
import fetch from 'cross-fetch';

const NewAccount = ({ onClose }) => {
    const [userEmail, setUserEmail] = useState("");
    const [operator, setOperator] = useState(false);
    const [signUp, setSignUp] = useState(false);
    const [aoc, aocChanged] = useState(false);
    const [validEmail, setValidEmail] = useState();
    const [userDetails, setUserDetails] = useState();
    const [handleSubmit, setHandleSubmit] = useFunction();

    const { error } = useErrorHandler(null);
    const alert = useAlert();
    useEffect(() => {
    if (isEmail(userEmail)) {
            setValidEmail(true);
        } else {
            setValidEmail(false);
        }
    }, [userEmail])

    const onSubmit = async (values) => {
        const res = await fetch(operator ? authEndpoints.enrolSupplier : authEndpoints.enrolClient,
            { method: "POST", headers: { "Content-type": "application/json" },
            body: JSON.stringify(values) });
        if (res) {
            const result = await res.json();

            alert({

                title: <h3>{result.success ? "Registration Successful" : "Failed to register!"}</h3>, body: <div>
                    <h5>{result.success ? "Registration Successful" : "Failed to register!"}</h5>
                    {result.messages && result.messages.length ? result.messages.map(x => <p>{x}</p>) : null}
                    {result.success ? <h6>Thanks for signing up!</h6> : null}
                    {result.success ? <h5> To finalise your registration, please check your email and follow the link we've sent. Let's get you flying.</h5> : null}
                </div>
                , onDismiss: () => {
                    onClose();

                }
            });
        } else {
            alert({
                title: <h3>Hmmm....</h3>,
                body: <h5>We couldnt register you.</h5>,
                onDismiss: () => { onClose(); }
            })
        }
    }

    const checkEmail = async () => {
        const result = await fetch(authEndpoints.checkEmailExists, {
            method: "POST", headers: { "Content-type": "application/json" },
            body: JSON.stringify({ email: userEmail })
        });
        if (await result.json()) {
            alert({ title: <h3>Account Already Exists!</h3>, body: <h5>You are registered with JetBidders. Maybe you need to reset your Password?</h5> })

        } else {
            const newI = operator ? entities.supplier.newItem({}) : entities.clientStaff.newItem({});
            const newItem = operator ? { ...newI, email: userEmail } : { ...newI, email: userEmail };
            setUserDetails(newItem);

        }

    }
    return <div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'centre' }}>
            <img alt='jetbidders' src={'/img/logo.png'} style={{ width: '60%', height: 'auto', marginTop: '5vh' }} />

        </div>
        {userDetails ? <FormContainer validationSchema={operator ? supplierShapeYup : clientStaffShapeYup} setHandleSubmit={setHandleSubmit} onSubmit={onSubmit} initialValues={userDetails} edit style={{ marginBottom: '100px' }}>
            {operator ? <Supplier /> : <ClientStaffDetail />}
        </FormContainer > :

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'centre' }}>
                <div style={{ width: '80%', marginTop: '30px' }}>
                    <h2>Welcome to JetBidders</h2>
                    {!signUp ? <h3 style={{ marginTop: '30px', marginBottom: '15px' }}>New Account Type:</h3> : <h3 style={{ marginTop: '30px', marginBottom: '15px' }}>Your Email:</h3>}
                    <Col>
                        {!signUp ? <FormGroup check style={{ marginTop: '15px', fontSize: '18px' }}>
                            <Label check>
                                <Input style={{ marginTop: '8px' }} type="radio" name={"userType"} onChange={() => setOperator(false)} checked={!operator} />{' '}I want to book flights
                            </Label>
                        </FormGroup> : null}
                        {!signUp ? <FormGroup check style={{ marginBottom: '15px', fontSize: '18px' }}>
                            <Label check>
                                <Input style={{ marginTop: '8px' }} type="radio" name={"userType"} onChange={() => setOperator(true)} checked={operator} /> {' '}I am an Air Operator

                            </Label>
                        </FormGroup> : null}



                    </Col>
                    {operator ? <FormGroup style={{ marginBottom: '5vh' }}>
                        <Label>My Air Operator Certificate Number</Label>
                        <Input type="Text" name={"AOC"} onChange={aocChanged} placeholder='Please enter your AOC number' />
                    </FormGroup> : null}
                    {signUp && !userDetails ? <FormGroup style={{ marginBottom: '5vh' }}>
                        <Input size='lg'
                            type="email"
                            name="email"
                            value={userEmail}
                            placeholder="your email"
                            onChange={e => setUserEmail(e.target.value)}
                        />
                    </FormGroup> : null}
                </div>
            </div>}
        <div style={{
            marginBottom: '50px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'
        }}>
            <div style={{ width: '80%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>

                {!userDetails && <Button style={{ width: '40%' }} color='secondary' type='button' onClick={signUp ? () => userDetails ? setUserDetails() : setSignUp(false) : onClose}  >Go Back</Button>}
                {(!userDetails && !signUp && (!operator || aoc)) && < Button style={{ width: '40%' }} color='primary' type='button' onClick={() => setSignUp(true)}>Next</Button>}
                {!userDetails && (signUp && validEmail) && < Button style={{ width: '40%' }} color='primary' type='button' onClick={() => checkEmail()}>Check Email</Button>}
                {error && <ErrorMessage errorMessage={error} />}
            </div>
            <Col>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>

                    {userDetails && <Button color='secondary' type='button' onClick={signUp ? () => userDetails ? setUserDetails() : setSignUp(false) : onClose}  >Go Back</Button>}
                    {userDetails && < Button color='primary' type='button' onClick={() => handleSubmit()}>Join JetBidders!</Button>}

                </div>


            </Col>
            <div style={{ width: '80%', marginTop: '25px' }}>
                <p>© Copyright Avmin {new Date().getFullYear()} All rights reserved</p>
                <a href='https://www.avmin.com.au/privacy-policy'>Our Privacy Policy</a>
            </div>
        </div>
    </div>
}

export default NewAccount;